// FUNÇÕES/MÓDULOS SITE
import sendForm from './modules/sendForm';

sendForm();

import email from './modules/email'
//sendForm();
email();